import { useContext, useEffect } from "react";

import ShowSuccessToastContext from "@context/ShowSuccessToast/showSuccessToastContext";
import { Alert, AlertTitle, Snackbar, Stack } from "@mui/material";

const SuccessToast = () => {
  const [{ showSuccessToastState, showSuccessToastSetState }] = useContext(
    ShowSuccessToastContext
  );

  const handleClose = () => {
    showSuccessToastSetState({
      ...showSuccessToastState,
      open: false,
      successMessage: "",
      successTitle: "",
    });
  };

  useEffect(() => {
    return () => {
      showSuccessToastSetState({
        ...showSuccessToastState,
        open: false,
        successMessage: "",
        successTitle: "",
      });
    };
  }, []);

  return (
    <div>
      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          open={showSuccessToastState?.open}
          autoHideDuration={2000}
          onClose={handleClose}
        >
          <Alert
            onClose={handleClose}
            severity="success"
            sx={{ width: "100%" }}
          >
            <AlertTitle>{showSuccessToastState?.successTitle}</AlertTitle>
            {showSuccessToastState?.successMessage}
          </Alert>
        </Snackbar>
      </Stack>
    </div>
  );
};
export default SuccessToast;
